import {
  AUTH_USER,
  AUTH_USER_OUT,
  SIGH_UP_USER,
  FORGOT_PASSWORD,
  UPDATE_PASSWORD,
} from './types';

let initialState = {
  isUserLoggedIn: false,
  token: null,
  forgotPasswordSent: false,
  passwordUpdated: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SIGH_UP_USER:
      return state;
    case FORGOT_PASSWORD:
      return {
        ...state,
        forgotPasswordSent: true,
      };
    case UPDATE_PASSWORD:
      return {
        ...state,
        passwordUpdated: true,
      };
    case AUTH_USER:
      return {
        ...state,
        isUserLoggedIn: action.isUserLoggedIn,
        token: action.token,
      };
    case AUTH_USER_OUT:
      return {
        ...state,
        isUserLoggedIn: false,
        token: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js